
var aRequests = new Array(0);
var aMustReloadPages = new Array(0);
var aResultsDestinations = new Array(0);
var aLoadingBoxes = new Array(0);
var bDispatcherIsRunning = false;


var DispatcherRequest = {
    bMustReloadPage: false,
    sResultsDestination: '',
    sLoadingBox: '',
    sGeneralLoadingBox: '',
    objHTMLRequest: null,
    nNextIdCall: -1
}

var DispatcherRequests = new Array(0);

function NoCache() {
    var d = new Date()
    var n = d.getTime()
    return n
}

function FormCommands_Disable() {
    if (document.getElementById('cmdExecute_01') != null) {
        document.getElementById('cmdExecute_01').disabled = true;
    };
    if (document.getElementById('cmdExecute_02') != null) {
        document.getElementById('cmdExecute_02').disabled = true;
    };
    if (document.getElementById('cmdExecute_03') != null) {
        document.getElementById('cmdExecute_03').disabled = true;
    };
    if (document.getElementById('cmdExecute_04') != null) {
        document.getElementById('cmdExecute_04').disabled = true;
    };
    if (document.getElementById('cmdExecute_05') != null) {
        document.getElementById('cmdExecute_05').disabled = true;
    };

}

function FormCommands_Enable() {
    if (document.getElementById('cmdExecute_01') != null) {
        document.getElementById('cmdExecute_01').disabled = false;
    };
    if (document.getElementById('cmdExecute_02') != null) {
        document.getElementById('cmdExecute_02').disabled = false;
    };
    if (document.getElementById('cmdExecute_03') != null) {
        document.getElementById('cmdExecute_03').disabled = false;
    };
    if (document.getElementById('cmdExecute_04') != null) {
        document.getElementById('cmdExecute_04').disabled = false;
    };
    if (document.getElementById('cmdExecute_05') != null) {
        document.getElementById('cmdExecute_05').disabled = false;
    };

}


function HideDispatcherExecute(TargetElement) {
    Modal_Hide();
    FormCommands_Enable();
    if (document.getElementById(TargetElement) != null) { document.getElementById(TargetElement).innerHTML = ""; }
    sleep(200);
}

function ShowDispatcherExecute(TargetElement) {
    HideDispatcherExecute(TargetElement);
    FormCommands_Disable();
    if (document.getElementById(TargetElement) !== null) {
        setTimeout(function () { document.getElementById(TargetElement).innerHTML = '<img src="Assets/Images/icons/spinner_30x14.gif" />'; }, 20);
    }


}

function GetSyncInfoForObject(IdProfile, IdParameter, IdObject, DestinationElement, Title) {
    var LocalRequest = new XMLHttpRequest();
    var TextReturned;
    DestinationElement = Trim(DestinationElement);

    if (DestinationElement == '')
    /* la risposta sarà un testo utile per una msgbox */ { LocalRequest.open('GET', 'SPObjectInfo.aspx?IdResponseType=1&IdParameter=' + IdParameter + '&IdProfile=' + IdProfile + '&IdObject=' + IdObject, false); }
    else
        if (DestinationElement == 'CKLLOG') {
            /* la risposta alimenterà l'OFFCANVAS */ { LocalRequest.open('GET', 'SPObjectInfo.aspx?IdResponseType=1&IdParameter=' + IdParameter + '&IdProfile=' + IdProfile + '&IdObject=' + IdObject, false); };
        }
        else
            /* la risposta sarà un testo utile per innerhtml */ { LocalRequest.open('GET', 'SPObjectInfo.aspx?IdResponseType=2&IdParameter=' + IdParameter + '&IdProfile=' + IdProfile + '&IdObject=' + IdObject, false); };




    LocalRequest.send(null);  /* invio la richiesta */
    TextReturned = LocalRequest.responseText; /* ottengo la risposta */

    if (LocalRequest.status === 200) {

        if (DestinationElement == 'CKLLOG') {
            addContentOffcanvas(Title, LocalRequest.responseText);
        }
        else {
            if (DestinationElement === '') {
                if (Left(TextReturned, 2) === 'KO') { return '' }
                else { return LocalRequest.responseText }
            }



        }

    }
    else { return ''; }
}


// FV 2026-06-09 - Mostra le info di un oggetto nella modale informativa (Info_Show),
// al posto di Modal_Show tipo 1/2 che usa
// GetSyncInfoForObject quando ha un DestinationElement. Stesso contenuto (ResponseType=2).
function ShowObjectInfoModal(IdProfile, IdParameter, IdObject, Title) {
    var req = new XMLHttpRequest();
    req.open('GET', 'SPObjectInfo.aspx?IdResponseType=2&IdParameter=' + IdParameter + '&IdProfile=' + IdProfile + '&IdObject=' + IdObject, false);
    req.send(null);
    var txt = (req.status === 200) ? req.responseText : '';
    if (Left(txt, 2) === 'KO') { txt = txt.substring(2); }
    if (Trim(txt) === '') { txt = 'Nessuna informazione disponibile.'; }
    Info_Show(Title, txt);
    return false;
}




function CallBackHandler(IdCall, WithExecuteWindow) {
    return function () {
        var CurrentRequest;
        var HTMLResult;
        var HTMLErrorText;

        CurrentRequest = DispatcherRequests[IdCall].objHTMLRequest;

        if (CurrentRequest == null) { return true };

        if (CurrentRequest.readyState == 4) {


            if (CurrentRequest.status == 200) {



                HTMLResult = CurrentRequest.responseText;
                if (HTMLResult.indexOf('|||') > 0) { HTMLResult = Left(HTMLResult, HTMLResult.indexOf('|||')) /* tronca la parte di testo superflua*/ };


                switch (Left(HTMLResult, 4)) {

                    case '*OK*':
                        if (Left(DispatcherRequests[IdCall].sResultsDestination, 7) == 'chk_150') {
                            // Acquisisco il numero di notifiche non lette
                            TestObject = document.getElementById('ps_notify_unreadcount');
                            if (TestObject != null) {
                                v000_TempInteger01 = Number(TestObject.innerHTML);

                                if (DispatcherRequests[IdCall].objHTMLRequest.responseURL.search('Type=C') >= 0) {
                                    // Se la richiesta era di impostare come letta una notifica allora scalo 1
                                    v000_TempInteger01 = v000_TempInteger01 - 1;
                                }
                                else {
                                    // Se la richiesta era di impostare come NON letta una notifica allora aggiungo 1
                                    v000_TempInteger01 = v000_TempInteger01 + 1;
                                }

                                TestObject.innerHTML = v000_TempInteger01;

                                TestObject.classList.remove("bg-danger");
                                TestObject.classList.remove("bg-success");

                                if (v000_TempInteger01 == 0) {
                                    TestObject.classList.add("bg-success");
                                    // FV - 2026-06-18 - era Modal_Show (testo di attesa): migrato a Modal_ShowWait, la funzione dedicata allo spinner di attesa
                                    Modal_ShowWait('', 'Aggiornamento dati in corso...');

                                    window.location.reload();
                                }
                                else {
                                    TestObject.classList.add("bg-danger");
                                }


                            }



                        }
                        else {
                            document.getElementById(DispatcherRequests[IdCall].sResultsDestination).innerHTML = '<p class=AJAX_OK>' + HTMLResult.substring(4) + '</p>';
                        }

                        break;

                    case '*KO*':
                        if (Left(DispatcherRequests[IdCall].sResultsDestination, 7) == 'chk_150') {
                            alert("Si è verificato un problema durante l'aggiornamento dello stato di lettura")
                        }
                        else {
                            document.getElementById(DispatcherRequests[IdCall].sResultsDestination).innerHTML = '<p class=AJAX_KO>' + HTMLResult.substring(4) + '</p>';
                        }

                        break;

                    default:
                        setTimeout(function () { Modal_Hide() }, 100);

                        switch (Left(DispatcherRequests[IdCall].sResultsDestination, 3)) {
                            case 'txt':
                                document.getElementById(DispatcherRequests[IdCall].sResultsDestination).value = HTMLResult;
                                break;
                            default:

                                try {
                                    ResultElement = document.getElementById(DispatcherRequests[IdCall].sResultsDestination);
                                    ResultElement.innerHTML = HTMLResult;
                                }
                                catch {

                                    HTMLResult = HTMLResult;
                                }

                        }

                }

                if (DispatcherRequests[IdCall].bMustReloadPage) { window.location.reload(); }
                else {

                    FormCommands_Enable();

                    if (DispatcherRequests[IdCall].nNextIdCall >= 0) {
                        bDispatcherIsRunning = true;
                        if (WithExecuteWindow) { ShowDispatcherExecute(DispatcherRequests[DispatcherRequests[IdCall].nNextIdCall].sLoadingBox); }

                        if (DispatcherRequests[DispatcherRequests[IdCall].nNextIdCall].nNextIdCall > 0) { DispatcherRequests[DispatcherRequests[IdCall].nNextIdCall].objHTMLRequest.onreadystatechange = CallBackHandler(DispatcherRequests[IdCall].nNextIdCall, WithExecuteWindow); }
                        else { DispatcherRequests[DispatcherRequests[IdCall].nNextIdCall].objHTMLRequest.onreadystatechange = CallBackHandler(DispatcherRequests[IdCall].nNextIdCall, false); }

                        setTimeout("DispatcherRequests[" + DispatcherRequests[IdCall].nNextIdCall + "].objHTMLRequest.send(null)", 100)
                    }
                    else {

                        TestObject = GetCTLSafeObjectById('TS_Calc_Total');
                        if (TestObject != null) {
                            if (TestObject.value == '1') {
                                TestObject.value = '0';
                                setTimeout("Dispatcher(402,'','divTimesheetLoadingData')", 200);
                            }

                            else {
                                TestObject.value = '1';

                            }

                        };

                        if (WithExecuteWindow) { HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); }
                        bDispatcherIsRunning = false;
                    }

                    if (DispatcherRequests[IdCall].sGeneralLoadingBox != '') {
                        if (WithExecuteWindow) { HideDispatcherExecute(DispatcherRequests[IdCall].sGeneralLoadingBox); }

                    }

                };

            }

        }

    }
}

function handleEvent(e) {
    console.log(JSON.parse(JSON.stringify(e)));
}

function addListeners(xhr) {
    xhr.addEventListener('loadstart', handleEvent);
    xhr.addEventListener('load', handleEvent);
    xhr.addEventListener('loadend', handleEvent);
    xhr.addEventListener('progress', handleEvent);
    xhr.addEventListener('error', handleEvent);
    xhr.addEventListener('abort', handleEvent);
}

function CreateXmlHttpReq() {
    var xmlhttp = null;
    try {
        xmlhttp = new XMLHttpRequest();
    } catch (e) {
        try {
            xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
            try { xmlhttp = new ActiveXObject("Microsoft.XMLHTTP"); }
            catch (e) { xmlhttp = null; }

        }
    }
    if (xmlhttp !== null) { addListeners(xmlhttp); }

    return xmlhttp;
}


function Dispatcher(IdCaller, StringParameter, GeneralLoadingBox) {
    var v000_StringToSend;
    var v000_TempInteger01;
    var v000_TempInteger02;
    var v000_TempInteger03;
    var v000_TempString01;
    var v000_TempBoolean01;

    var v000_ObjectInfo;
    var v000_Counter01;
    var v000_Counter02;
    var v000_Items01;
    var v000_Items02;
    var v000_IdUserToUse;
    var v000_TDId;
    var v000_RowId;
    var v00_IdCall_Previous; //Per array di chiamate indica l'indice dell'array della chiamata precedente
    var v00_IdCall_First; //Per array di chiamate indica l'indice dell'array della prima chiamata
    var TestObject;

    var AtLeastOneValueChanged = false;

    var TS_Date_Min = '';
    var TS_Date_Max = '';

    /*
    CODICE  PAGINA          DESCRIZIONE
    101 -   SPCP_System     Imposta il progressivo dell'ultima fattura emessa per un anno
    102 -   SPCP_System     Imposta il progressivo dell'ultima proforma emessa per un anno
    371 -   SPCP_Invoices   Elimina una fattura
    372 -   SPCP_Invoices   Aggiorna il protocollo di una fattura
    381 -   SPCP_Proformas  Elimina una proforma
    382 -   SPCP_Proformas  Aggiorna il protocollo di una proforma

    400 -   SPEmpty         Estraggo dal db i valori delle celle del TimeSheet 
    401 -   SPEmpty         Salvo i valori di un elenco di celle del timesheet (il parametro StringParameter indica l'elenco dei TDId delle celle
    402 -   SPEmpty         Estraggo dal db i totali di ore e spese 

    500 -   SPRequest       Ottiene i dettagli della richiesta per poter cliccare su ACCETTA o RIFIUTA
    501 -   SPEmpty         Accetta la richiesta
    502 -   AppSettings     Ottiene il log di un item di una checklist

    503 -   Cambia lo stato di lettura di una notifica
    504 -   Imposta come letta ogni notifica non letta presente nella dashboard
    */


    if (IdCaller == 371) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_01',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;
        v00_IdCall_First = IdCall;

        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLIdInvoiceToDelete_txtValue_Int");
        v000_TempInteger01 = Trim(TestObject.value);
        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire un ID fattura valido da eliminare'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 <= 0) { alert('Occorre fornire un ID fattura valido da eliminare'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_ObjectInfo = GetSyncInfoForObject(37, 0, v000_TempInteger01, '', '')
        if (v000_ObjectInfo == '') { alert('Fattura non trovata o non modificabile.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        if (!confirm('Fattura da eliminare' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_ObjectInfo + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=37&ResponseType=2&Type=D&Id=" + v000_TempInteger01;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);
        return false;
    };

    if (IdCaller == 372) {

        if (bDispatcherIsRunning == true) { alert('Attendere il completamento dell\'operazione precedente.'); return false; }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_02',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;

        v00_IdCall_First = IdCall;

        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLIdInvoiceToUpdate_txtValue_Int");
        v000_TempInteger01 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire un ID fattura valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 <= 0) { alert('Occorre fornire un ID fattura valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_ObjectInfo = GetSyncInfoForObject(37, 0, v000_TempInteger01, '', '')

        if (v000_ObjectInfo == '') {
            HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox);
            alert('Fattura non trovata o non modificabile.');
            return false;
        }

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLNewProtocol_txtValue_Int");
        v000_TempInteger02 = Trim(TestObject.value);


        if (!isNumber(v000_TempInteger02)) { alert('Occorre fornire un nuovo progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger02 <= 0) { alert('Occorre fornire un nuovo progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        if (!confirm('Fattura da modificare' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_ObjectInfo + String.fromCharCode(10) + String.fromCharCode(10) + 'NUOVO PROGRESSIVO: ' + v000_TempInteger02 + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=37&ResponseType=2&Type=UPDPRT&Id=" + v000_TempInteger01 + '&NewCounter=' + v000_TempInteger02;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();


        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);
        return false;
    };



    if (IdCaller == 381) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_01',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;
        v00_IdCall_First = IdCall;

        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLIdProformaToDelete_txtValue_Int");
        v000_TempInteger01 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire un ID proforma valido da eliminare'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 <= 0) { alert('Occorre fornire un ID proforma valido da eliminare'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_ObjectInfo = GetSyncInfoForObject(29, 0, v000_TempInteger01, '', '');
        if (v000_ObjectInfo == '') { alert('Proforma non trovata o non modificabile.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        if (!confirm('Proforma da eliminare' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_ObjectInfo + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=29&ResponseType=2&Type=D&Id=" + v000_TempInteger01;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);
        return false;
    };

    if (IdCaller == 382) {

        if (bDispatcherIsRunning == true) { alert('Attendere il completamento dell\'operazione precedente.'); return false; }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_02',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;

        v00_IdCall_First = IdCall;

        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLIdProformaToUpdate_txtValue_Int");
        v000_TempInteger01 = Trim(TestObject.value);


        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire un ID proforma valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 <= 0) { alert('Occorre fornire un ID proforma valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_ObjectInfo = GetSyncInfoForObject(29, 0, v000_TempInteger01, '', '');

        if (v000_ObjectInfo == '') {
            HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox);
            alert('Proforma non trovata o non modificabile.');
            return false;
        }

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLNewProtocol_txtValue_Int");
        v000_TempInteger02 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger02)) { alert('Occorre fornire un nuovo progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger02 <= 0) { alert('Occorre fornire un nuovo progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        if (!confirm('Proforma da modificare' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_ObjectInfo + String.fromCharCode(10) + String.fromCharCode(10) + 'NUOVO PROGRESSIVO: ' + v000_TempInteger02 + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=29&ResponseType=2&Type=UPDPRT&Id=" + v000_TempInteger01 + '&NewCounter=' + v000_TempInteger02;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();


        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);
        return false;
    };




    if (IdCaller == 101) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_03',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;


        v00_IdCall_First = IdCall;



        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboProtocolYears");
        v000_TempInteger01 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire l\'anno dif riferimento'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 < 0) { alert('Occorre fornire l\'anno dif riferimento'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLLastCounter_txtValue_Int");
        v000_TempInteger02 = Trim(TestObject.value);


        if (!isNumber(v000_TempInteger02)) { alert('Occorre fornire un progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger02 < 0) { alert('Occorre fornire un progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntityProtocols");
        v000_TempInteger03 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger03)) { alert('Occorre fornire un\'entità di fatturazione valida'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger03 <= 0) { alert('Occorre fornire un\'entità di fatturazione valida'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_TempString01 = '';

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntities");

        v000_TempString01 = v000_TempString01 + Trim(TestObject.options[TestObject.selectedIndex].text);
        v000_TempString01 = v000_TempString01 + ' - ';

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntityProtocols");

        v000_TempString01 = v000_TempString01 + Trim(TestObject.options[TestObject.selectedIndex].text);


        if (!confirm('PROGRESSIVO FATTURA' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_TempString01 + String.fromCharCode(10) + 'Per l\'anno ' + v000_TempInteger01 + ' il progressivo dell\'ultima fattura emessa diventerà ' + v000_TempInteger02 + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=100&ResponseType=2&Type=UPD_INV_PROT_COUNTER&Parameter01=" + v000_TempInteger01 + '&Parameter02=' + v000_TempInteger02 + '&Parameter03=' + v000_TempInteger03;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);

        return false;
    };



    if (IdCaller == 102) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: 'divResults_03',
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;


        v00_IdCall_First = IdCall;



        ShowDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); /* Visualizzo il caricamento svuotando i risultati precedenti */

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboProtocolYears");
        v000_TempInteger01 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger01)) { alert('Occorre fornire l\'anno dif riferimento'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger01 < 0) { alert('Occorre fornire l\'anno dif riferimento'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_LVLLastCounter_txtValue_Int");
        v000_TempInteger02 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger02)) { alert('Occorre fornire un progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger02 < 0) { alert('Occorre fornire un progressivo valido'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntityProtocols");
        v000_TempInteger03 = Trim(TestObject.value);

        if (!isNumber(v000_TempInteger03)) { alert('Occorre fornire un\'entità di fatturazione valida'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }
        if (v000_TempInteger03 <= 0) { alert('Occorre fornire un\'entità di fatturazione valida'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_TempString01 = '';

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntities");

        v000_TempString01 = v000_TempString01 + Trim(TestObject.options[TestObject.selectedIndex].text);
        v000_TempString01 = v000_TempString01 + ' - ';

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboBILEntityProtocols");

        v000_TempString01 = v000_TempString01 + Trim(TestObject.options[TestObject.selectedIndex].text);


        if (!confirm('PROGRESSIVO PROFORMA' + String.fromCharCode(10) + '' + String.fromCharCode(10) + v000_TempString01 + String.fromCharCode(10) + 'Per l\'anno ' + v000_TempInteger01 + ' il progressivo dell\'ultima proforma emessa diventerà ' + v000_TempInteger02 + String.fromCharCode(10) + String.fromCharCode(10) + 'Si vuole proseguire?')) { alert('Operazione annullata.'); HideDispatcherExecute(DispatcherRequests[IdCall].sLoadingBox); return false; }

        v000_StringToSend = "IdProfile=100&ResponseType=2&Type=UPD_PROF_PROT_COUNTER&Parameter01=" + v000_TempInteger01 + '&Parameter02=' + v000_TempInteger02 + '&Parameter03=' + v000_TempInteger03;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
        DispatcherRequests[IdCall].objHTMLRequest.send(null);

        return false;
    };



    if (IdCaller == 400) {

        var v400_asRowIDs;
        var v400_asDates;
        var v400_hidRowIDs;
        var v400_hidDates;

        var v400_IdProfileToSum;
        var v400_LastIdWork = -1;
        var v400_IdWork = -1;

        var TestValue;

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_hidTimesheet_RowIds");

        if (TestObject == null) { return false };

        v000_IdUserToUse = TestObject.value;
        if (v000_IdUserToUse <= 0) { alert('Selezionare un utente valido.'); return false; }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_hidIdProfileToSum");

        v400_IdProfileToSum = TestObject.value;



        if (StringParameter == '') {
            // Acquisisco l'elenco dei RowId dal campo nascosto ctl00_cphNavigation_hidTimesheet_RowIds quindi carico tutti gli elementi della pagina

            TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_hidTimesheet_RowIds");

            v400_hidRowIDs = TestObject.value; //Acqusisisco dalla pagina l'elenco degli ID di riga
        }
        else {
            // Acquisisco l'elenco dei RowId come parametro quindi carico tutti gli elementi della riga indicata
            v400_hidRowIDs = StringParameter;
        }

        if (v400_hidRowIDs == '')
        //Non ci sono elementi per il timesheet
        {
            if (document.getElementById('divTimesheetLoadingData') != null) {
                setTimeout("document.getElementById('divTimesheetLoadingData').innerHTML=''", 50);
            }

            return false;
        }


        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_hidTimesheet_Dates");

        v400_hidDates = TestObject.value; //Acqusisisco dalla pagina l'elenco delle date selezionate


        v400_asRowIDs = v400_hidRowIDs.split(','); // Creao l'array con l'elenco degli ID di riga
        v400_asDates = v400_hidDates.split(','); // Creao l'array con l'elenco delle date

        v000_Items01 = v400_asRowIDs.length;
        v000_Items02 = v400_asDates.length;


        v00_IdCall_IsFirst = true;
        v00_IdCall_First = -1;

        // Per ogni Riga del timesheet
        for (v000_Counter01 = 0; v000_Counter01 < v000_Items01; v000_Counter01++) {


            // Per ogni colonna del Timesheet
            for (v000_Counter02 = 0; v000_Counter02 < v000_Items02; v000_Counter02++) {

                // Per ogni ID di riga è sufficiente aggiungere la data per avere il TDId della cella
                v000_TDId = v400_asRowIDs[v000_Counter01] + "_" + v400_asDates[v000_Counter02];

                //preparo l'Array delle richieste senza lanciare le richieste

                //La richiesta restituisce il contenuto completo HTML della cella richiesta
                v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=1&SumType=10&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: v000_TDId,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;

                if ((v000_Counter01 == (v000_Items01 - 1)) && (v000_Counter02 == (v000_Items02 - 1))) {
                    DispatcherRequests[IdCall].sGeneralLoadingBox = GeneralLoadingBox;
                }
                else {
                    DispatcherRequests[IdCall].sGeneralLoadingBox = '';
                }

                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);

                if (v00_IdCall_IsFirst == true) {
                    v00_IdCall_First = IdCall;
                    v00_IdCall_IsFirst = false;
                }
                else { DispatcherRequests[IdCall - 1].nNextIdCall = IdCall; }


                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

            };

            // Al termine del contatore di colonna aggiungo due richiesta all'array per calcolare l'utilizzo delle ore


            //Creo un oggetto Richiesta apposito per aggiornare la somma delle ore utilizzate relative a pratica/fascicolo/attività/data sulla pagina del timesheet
            v000_RowId = Left(v400_asRowIDs[v000_Counter01], 22);
            v000_TDId = v000_RowId + '_sum_used';
            v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=11&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
            v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();


            IdCall = DispatcherRequests.push({
                sGeneralLoadingBox: '',
                bMustReloadPage: false,
                sResultsDestination: v000_TDId,
                sLoadingBox: v000_TDId,
                objHTMLRequest: CreateXmlHttpReq(),
                nNextIdCall: -1
            }
            ) - 1;
            DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
            DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

            DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;


            //Creo un oggetto Richiesta apposito per aggiornare la somma delle ore inutilizzate relative a pratica/fascicolo/attività/data  sulla pagina del timesheet
            v000_RowId = Left(v400_asRowIDs[v000_Counter01], 22);
            v000_TDId = v000_RowId + '_sum_unused';
            v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=10&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
            v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

            IdCall = DispatcherRequests.push({
                sGeneralLoadingBox: '',
                bMustReloadPage: false,
                sResultsDestination: v000_TDId,
                sLoadingBox: v000_TDId,
                objHTMLRequest: CreateXmlHttpReq(),
                nNextIdCall: -1
            }
            ) - 1;
            DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
            DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

            DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;



            //Acquisisco l'Id della pratica in questione
            v400_IdWork = v000_TDId.substring(4, 10)
            //Verifico se l'Id della pratica è differente dall'ultima pratica analizzata
            if (v400_IdWork != v400_LastIdWork) {
                v400_LastIdWork = v400_IdWork; //Ricordo quale è l'ultima pratica analizzata

                v000_RowId = Left(v000_TDId, 17) + '_0000'//Calcolo il RowId della riga che gestisce i totali della pratica, a prescindere dall'attività

                //Aggiungo 2 richieste all'array per calcolare i totali ore usate e non usate generali per la pratica
                v000_TDId = v000_RowId + '_sum_used';
                v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=11&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: v000_TDId,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;

                v000_TDId = v000_RowId + '_sum_unused';
                v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=10&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: v000_TDId,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;


                //Aggiungo N richieste all'array per calcolare i totali ore non usate sulle singole date

                for (v000_Counter02 = 0; v000_Counter02 < v000_Items02; v000_Counter02++) {
                    // Per ogni ID di riga è sufficiente aggiungere la data per avere il TDId della cella
                    v000_TDId = v000_RowId + "_" + v400_asDates[v000_Counter02];

                    v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v400_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=10&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                    v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                    IdCall = DispatcherRequests.push({
                        sGeneralLoadingBox: '',
                        bMustReloadPage: false,
                        sResultsDestination: v000_TDId,
                        sLoadingBox: v000_TDId,
                        objHTMLRequest: CreateXmlHttpReq(),
                        nNextIdCall: -1
                    }
                    ) - 1;
                    DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                    DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                    DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;




                }


            }


        };




        if (v00_IdCall_First != -1) {
            DispatcherRequests[IdCall].sGeneralLoadingBox = GeneralLoadingBox; // L'ultima richiesta nasconderà il box di caricamento

            //Lancio la prima richiesta, sul CallBack verranno gestite le successive
            ShowDispatcherExecute(DispatcherRequests[v00_IdCall_First].sLoadingBox);
            setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);
        }

        return false;
    };


    if (IdCaller == 401) {

        var v401_IdProfileToSum_Object;
        var v401_IdProfileToSum_Object_Id;
        var v401_IdProfileToSum;
        var NewValue = '';



        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboTimesheetUsers");

        v000_IdUserToUse = TestObject.value;

        if (v000_IdUserToUse <= 0) { alert('Selezionare un utente valido.'); return false; }

        // Il parametro StringParameter indica l'elenco dei TDId da salvare
        var v401_asTDIds;
        var v401_RowSumID;

        v401_asTDIds = StringParameter.split(','); // Creao l'array con l'elenco dei TDId da salvare

        v000_Items01 = v401_asTDIds.length; //Numero di richieste

        v00_IdCall_IsFirst = true;
        v00_IdCall_First = -1;
        v401_RowSumID = '';

        for (v000_Counter01 = 0; v000_Counter01 < v000_Items01; v000_Counter01++) {

            v401_RowSumID = Left(v401_asTDIds[v000_Counter01], 27);
            v401_IdProfileToSum_Object_Id = 'txt_' + v401_asTDIds[v000_Counter01]
            TestObject = GetCTLSafeObjectById(v401_IdProfileToSum_Object_Id);
            NewValue = TestObject.value;

            if (NewValue == null) { NewValue = ''; }

            if ((NewValue != 'ERR') && (NewValue != '')) {

                AtLeastOneValueChanged = true;

                v401_IdProfileToSum = v401_IdProfileToSum_Object_Id.substring(22, 26);

                //Preparo la stringa di richiesta
                v000_StringToSend = 'Type=TMSH_UPD&IdProfile=' + Left(v401_asTDIds[v000_Counter01], 3) + '&ResponseType=2&IdProfileToSum=' + v401_IdProfileToSum + '&IdUserToUse=' + v000_IdUserToUse + '&TDId=' + v401_asTDIds[v000_Counter01] + '&NewValue=' + document.getElementById('txt_' + v401_asTDIds[v000_Counter01]).value;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                //Aggiungo un elemento all'array delle richieste . IdCall indicherà l'indice nell'array della richiesta appena creata
                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v401_asTDIds[v000_Counter01],
                    sLoadingBox: v401_asTDIds[v000_Counter01],
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;


                //Indico all'oggetto richiesta quale pagina contattare e con quali parametri
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);


                if (v00_IdCall_IsFirst == true) {
                    //E' il primo elemento aggiunto all'array, memorizzo l'indice dell'array
                    v00_IdCall_First = IdCall;
                    v00_IdCall_IsFirst = false;
                }
                else {
                    //Non è il primo elemento aggiunto.
                    //Indico all'elemento precedente che appena termina il callback deve avviare l'elemento successivo
                    DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;
                }

                //Indico all'oggetto Richiesta appena creato quale funzione chiamare sul callback
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);




                if (v401_IdProfileToSum == '0016') {

                    //Creo un oggetto Richiesta apposito per aggiornare il totale attività per giornata

                    v000_RowId = '016_000000_000000_0000'//Calcolo il RowId della riga che gestisce i totali della pratica, a prescindere dall'attività


                    v000_TDId = v000_RowId + '_' + v401_asTDIds[v000_Counter01].slice(-8);
                    v401_IdProfileToSum = 16;
                    v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v401_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=0&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                    v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                    IdCall = DispatcherRequests.push({
                        sGeneralLoadingBox: '',
                        bMustReloadPage: false,
                        sResultsDestination: v000_TDId,
                        sLoadingBox: v000_TDId,
                        objHTMLRequest: CreateXmlHttpReq(),
                        nNextIdCall: -1
                    }
                    ) - 1;
                    DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                    DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                    DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;

                }


                if (v401_IdProfileToSum == '0025') {
                    //Creo un oggetto Richiesta apposito per aggiornare il totale spese per giornata

                    v000_RowId = '025_000000_000000_0000'//Calcolo il RowId della riga che gestisce i totali della pratica, a prescindere dall'attività

                    v000_TDId = v000_RowId + '_' + v401_asTDIds[v000_Counter01].slice(-8);
                    v401_IdProfileToSum = 25;
                    v000_StringToSend = "IdProfile=" + Left(v000_TDId, 3) + "&IdParameter=1&IdProfileToSum=" + v401_IdProfileToSum + "&IdObject=0&IdResponseType=1&OutputType=2&SumType=0&IdUserToUse=" + v000_IdUserToUse + "&TDId=" + v000_TDId;
                    v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                    IdCall = DispatcherRequests.push({
                        sGeneralLoadingBox: '',
                        bMustReloadPage: false,
                        sResultsDestination: v000_TDId,
                        sLoadingBox: v000_TDId,
                        objHTMLRequest: CreateXmlHttpReq(),
                        nNextIdCall: -1
                    }
                    ) - 1;
                    DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                    DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                    DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;


                }





            }


        }

        if (GetCTLSafeObjectById('TS_Date_Min')) {
            TS_Date_Min = GetCTLSafeObjectById('TS_Date_Min').value;
            TS_Date_Max = GetCTLSafeObjectById('TS_Date_Max').value;


            if (v401_RowSumID != '') {




                v401_IdProfileToSum = Left(Right(v401_RowSumID, 9), 4);
                v000_StringToSend = "IdProfile=" + Left(v401_RowSumID, 3) + "&IdParameter=2&IdProfileToSum=" + v401_IdProfileToSum + "&IdObject=" + v401_RowSumID.substring(4, 10) + "&IdResponseType=1&SumType=" + Right(v401_RowSumID, 4) + "&IdUserToUse=" + v000_IdUserToUse;

                v401_RowSumID = "txt_" + Left(v401_RowSumID, 10) + "_" + Right(v401_RowSumID, 9) + '_' + TS_Date_Min + '_' + TS_Date_Max + "_tot";
                v000_StringToSend = v000_StringToSend + "&TDId=" + v401_RowSumID; // txt_014_011132_0016_0072_20241101_20241130_tot
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v401_RowSumID,
                    sLoadingBox: v401_RowSumID,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

                DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;



            }

        }






        //Lancio la prima richiesta, sul CallBack verranno gestite le successive
        if (AtLeastOneValueChanged) {
            DispatcherRequests[IdCall].sGeneralLoadingBox = GeneralLoadingBox; //indico all'ultima chiamata di nascondere l'immagine di Loading

            ShowDispatcherExecute(DispatcherRequests[v00_IdCall_First].sLoadingBox);
            setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);
        }
        else {
            if (document.getElementById('divTimesheetLoadingData') != null) {
                HideDispatcherExecute('divTimesheetLoadingData');
            }

        }

        return false;
    };

    if (IdCaller == 402) {

        TestObject = GetCTLSafeObjectById("ctl00_cphNavigation_cboTimesheetUsers");

        v000_IdUserToUse = TestObject.value;

        if (v000_IdUserToUse <= 0) { alert('Selezionare un utente valido.'); return false; }

        AtLeastOneValueChanged = false;
        v00_IdCall_First = -1;
        v00_IdCall_IsFirst = true;

        if (GetCTLSafeObjectById('TS_Date_Min')) {
            TS_Date_Min = GetCTLSafeObjectById('TS_Date_Min').value;
            TS_Date_Max = GetCTLSafeObjectById('TS_Date_Max').value;

            //Acquisisco le righe modificate ricalcolando le somme

            TestValue = GetCTLSafeObjectById('ctl00_cphNavigation_hidTimesheet_RowIds');

            var v103_RowIDs = TestValue.value;
            var v103_aRowIds = v103_RowIDs.split(',');

            var tmpSourceType = '';
            var atmpSourcesTypes = [];
            var tmpItems = 0;

            v000_Items = v103_aRowIds.length;

            for (v000_Counter = 0; v000_Counter < v000_Items; v000_Counter++)
            // Ciclo tra tutti i RowId contenuti nel documento e acquisisco i codici Source/Type individuali modificati
            {
                if (TestDataChanged(v103_aRowIds[v000_Counter])) {

                    tmpSourceType = Left(v103_aRowIds[v000_Counter], 22);
                    tmpSourceType = Left(tmpSourceType, 10) + '_' + Right(tmpSourceType, 4);

                    if (!atmpSourcesTypes.includes(tmpSourceType)) {
                        atmpSourcesTypes.push(tmpSourceType);
                    }


                }
            }


            tmpItems = atmpSourcesTypes.length;
            for (v000_Counter = 0; v000_Counter < tmpItems; v000_Counter++) {

                v401_IdProfileToSum = Right(atmpSourcesTypes[v000_Counter], 4);
                v000_StringToSend = "IdProfile=" + Left(atmpSourcesTypes[v000_Counter], 3) + "&IdParameter=2&IdProfileToSum=" + v401_IdProfileToSum + "&IdObject=" + atmpSourcesTypes[v000_Counter].substring(4, 10) + "&IdResponseType=1&SumType=0" + "&IdUserToUse=" + v000_IdUserToUse;


                v401_RowSumID = Left(atmpSourcesTypes[v000_Counter], 3) + "_" + atmpSourcesTypes[v000_Counter].substring(4, 10) + '_' + Right(atmpSourcesTypes[v000_Counter], 4) + "_" + TS_Date_Min + '_' + TS_Date_Max + "_tot";
                v000_StringToSend = v000_StringToSend + "&TDId=" + v401_RowSumID; // 014_011132_0016_20241101_20241130_tot
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v401_RowSumID,
                    sLoadingBox: v401_RowSumID,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
                if (v00_IdCall_IsFirst) {
                    v00_IdCall_First = IdCall;
                    v00_IdCall_IsFirst = false;

                }
                else { DispatcherRequests[IdCall - 1].nNextIdCall = IdCall; }




            }







            //Creo un oggetto Richiesta apposito per aggiornare le ore totali
            //  tot_016_20241201_20241226

            v000_TDId = 'tot_016' + '_' + TS_Date_Min + '_' + TS_Date_Max;
            TestObject = GetCTLSafeObjectById(v000_TDId);
            if (TestObject != null) {
                AtLeastOneValueChanged = true;
                v000_StringToSend = "IdProfile=016&IdUserToUse=" + v000_IdUserToUse + "&IdParameter=2&IdObject=0&IdResponseType=1&Date_Min=" + TS_Date_Min + "&Date_Max=" + TS_Date_Max + "&TDId=" + v000_TDId;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: v000_TDId,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
                DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;
                if (v00_IdCall_IsFirst) {
                    v00_IdCall_First = IdCall;
                    v00_IdCall_IsFirst = false;

                }
                else { DispatcherRequests[IdCall - 1].nNextIdCall = IdCall; }

            }

            //Creo un oggetto Richiesta apposito per aggiornare le spese totali
            //  tot_025_20241201_20241226

            v000_TDId = 'tot_025' + '_' + TS_Date_Min + '_' + TS_Date_Max;
            TestObject = GetCTLSafeObjectById(v000_TDId);
            if (TestObject != null) {
                AtLeastOneValueChanged = true;
                v000_StringToSend = "IdProfile=025&IdUserToUse=" + v000_IdUserToUse + "&IdParameter=2&IdObject=0&IdResponseType=1&Date_Min=" + TS_Date_Min + "&Date_Max=" + TS_Date_Max + "&TDId=" + v000_TDId;
                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                IdCall = DispatcherRequests.push({
                    sGeneralLoadingBox: '',
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: v000_TDId,
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, false);
                if (v00_IdCall_IsFirst) {
                    v00_IdCall_IsFirst = true;
                    v00_IdCall_First = IdCall;
                }
                else { DispatcherRequests[IdCall - 1].nNextIdCall = IdCall; }


            }

        }



        //Lancio la prima richiesta, sul CallBack verranno gestite le successive
        if (AtLeastOneValueChanged) {
            DispatcherRequests[IdCall].sGeneralLoadingBox = GeneralLoadingBox; //indico all'ultima chiamata di nascondere l'immagine di Loading

            ShowDispatcherExecute(DispatcherRequests[v00_IdCall_First].sLoadingBox);
            setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);
        }
        else {
            if (document.getElementById('divTimesheetLoadingData') != null) {
                HideDispatcherExecute('divTimesheetLoadingData');
            }

        }






    }


    if (IdCaller == 500) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        v000_StringToSend = "IdProfile=63&IdParameter=1&IdResponseType=3&IdObject=" + StringParameter;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        // ShowDispatcherExecute(GeneralLoadingBox);

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: GeneralLoadingBox,
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;
        v00_IdCall_First = IdCall;


        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, false);

        setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);

        return false;
    };

    if (IdCaller == 502) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        v000_StringToSend = "IdProfile=120&IdParameter=1&IdResponseType=3&IdObject=" + StringParameter;
        v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

        //ShowDispatcherExecute(GeneralLoadingBox);

        IdCall = DispatcherRequests.push({
            bMustReloadPage: false,
            sResultsDestination: GeneralLoadingBox,
            sLoadingBox: '',
            sGeneralLoadingBox: '',
            objHTMLRequest: CreateXmlHttpReq(),
            nNextIdCall: -1
        }
        ) - 1;
        v00_IdCall_First = IdCall;


        DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPObjectInfo.aspx?" + v000_StringToSend, true);
        DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

        setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);

        return false;
    };

    if (IdCaller == 503) {

        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }


        TestObject = GetCTLSafeObjectById(StringParameter);
        if (TestObject != null) {


            v000_TempBoolean01 = TestObject.checked;
            v000_TempInteger01 = Number(StringParameter.substring(4, 7));
            v000_TempInteger02 = Number(StringParameter.substring(7));
            if (v000_TempInteger01 = 150 && v000_TempInteger02 > 0) {

                IdCall = DispatcherRequests.push({
                    bMustReloadPage: false,
                    sResultsDestination: StringParameter,
                    sLoadingBox: '',
                    sGeneralLoadingBox: '',
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;
                v00_IdCall_First = IdCall;

                if (v000_TempBoolean01) {
                    v000_StringToSend = "IdProfile=150&ConfirmationStatus=1&ResponseType=2&Type=C&Id=" + v000_TempInteger02;
                }
                else {
                    v000_StringToSend = "IdProfile=150&ConfirmationStatus=1&ResponseType=2&Type=RS&Id=" + v000_TempInteger02;
                }

                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);
                DispatcherRequests[IdCall].objHTMLRequest.send(null);

            }

        }
        return false;

    };


    if (IdCaller == 504) {


        if (bDispatcherIsRunning == true) {
            alert('Attendere il completamento dell\'operazione precedente.');
            return false;
        }

        v00_IdCall_IsFirst = true;
        v000_TempInteger01 = -1;
        v000_TempInteger02 = -1;
        v00_IdCall_First = -1;

        var notifications = $('.ps_notify_chk')
        notifications.each(function () {

            var notification_chk = $(this);
            v000_TDId = notification_chk.attr('id');
            v000_TempBoolean01 = notification_chk.is(":checked");

            v000_TempInteger01 = Number(v000_TDId.substring(4, 7));
            v000_TempInteger02 = Number(v000_TDId.substring(7));
            if ((!v000_TempBoolean01) && (v000_TempInteger01 = 150) && (v000_TempInteger02 > 0)) {

                IdCall = DispatcherRequests.push({
                    bMustReloadPage: false,
                    sResultsDestination: v000_TDId,
                    sLoadingBox: '',
                    sGeneralLoadingBox: '',
                    objHTMLRequest: CreateXmlHttpReq(),
                    nNextIdCall: -1
                }
                ) - 1;

                if (v00_IdCall_IsFirst == true) {
                    //E' il primo elemento aggiunto all'array, memorizzo l'indice dell'array
                    v00_IdCall_First = IdCall;
                    v00_IdCall_IsFirst = false;
                }
                else {
                    //Non è il primo elemento aggiunto.
                    //Indico all'elemento precedente che appena termina il callback deve avviare l'elemento successivo
                    DispatcherRequests[IdCall - 1].nNextIdCall = IdCall;
                }

                v000_StringToSend = "IdProfile=150&ConfirmationStatus=1&ResponseType=2&Type=C&Id=" + v000_TempInteger02;

                v000_StringToSend = v000_StringToSend + "&Test=" + NoCache();

                DispatcherRequests[IdCall].objHTMLRequest.open("GET", "SPHiddenCommands.aspx?" + v000_StringToSend, true);
                DispatcherRequests[IdCall].objHTMLRequest.onreadystatechange = CallBackHandler(IdCall, true);

            }


        })



        if (v00_IdCall_First >= 0) {

            //Imposto l'ultima richiesta con l'obbligo di ricricare la pagina
            DispatcherRequests[IdCall].bMustReloadPage = true;

            //Lancio la prima richiesta, sul CallBack verranno gestite le successive
            setTimeout("DispatcherRequests[" + v00_IdCall_First + "].objHTMLRequest.send(null)", 200);
        }

    };


}




